import { getAssetUrl as assetUrl, type ImgixParams, getImageUrl as imageUrl } from '@takeshape/routing';
import { assetBaseUrl, defaultImageConfig, imageBaseUrl } from 'app/config';
import startsWith from 'lodash/startsWith';

export function getImageUrl(path: string, config?: ImgixParams): string {
  return imageUrl(path, { ...defaultImageConfig, ...config }, { baseUrl: imageBaseUrl });
}

export function getAssetUrl(path: string): string {
  return assetUrl(path, { baseUrl: assetBaseUrl });
}

export function getDownloadUrl(path: string, mimeType: string): string {
  const isImage = startsWith(mimeType, 'image/');
  return isImage ? getImageUrl(path) : getAssetUrl(path);
}
